module.exports = __webpack_public_path__ + "images/avatar-fengdahui-6fa8d4428c38937ac4168f7a85528fc8.png";